import Vue from "vue";
import VueI18n from "vue-i18n";
import brand from "./brand";
Vue.use(VueI18n);
function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    false,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  // Pridge-only strings (client, technician, ...) on top of the shared ones.
  if (brand.isPridge) {
    ["ar", "en"].forEach((locale) => {
      messages[locale] = {
        ...messages[locale],
        ...require(`./locales/pridge/${locale}.json`),
      };
    });
  }
  return messages;
}

export default new VueI18n({
  locale: localStorage.getItem("Lang") || "ar", // set default locale
  fallbackLocale: localStorage.getItem("Lang") || "ar", // set default locale
  rtl: true,
  silentTranslationWarn: true,
  messages: loadLocaleMessages(),
});
